import { toStringify } from '../utils/smartutils';

export function schoolClassListByFilterQuery(filter) {
  const filterReassign = { ...filter };
  const { courseStep, team } = filterReassign;
  if (team && team.length) {
    filterReassign.team = team.map(({ label, value, ...rest }) => rest);
  }
  if (courseStep && courseStep.id) {
    const { label, value, ...rest } = courseStep;
    filterReassign.courseStep = rest;
  }
  return `{classListByFilter(filter: ${toStringify(filterReassign)}) {
    id
    name
    shortName
    active
    year
    capacity
    studentsQuantity
    schoolGrade {
      id
      name
      active
      order
    }
    term {
      id
      name
      year
      initialDate
      finalDate
    }
    responsible {
      id
      name
    }
    responsibleAux {
      id
      name
    }
    singleClassShift
    courseStep {
      id
      fullName
      cycleQuantity
      value
      label
      course {
        id
        name
        value
        label
      }
    }
    academicCalendar {
      id
      name
      value
      label
    }
    classShift {
      id
      name
      value
      label
    }
  }
}`;
}

export function schoolClassSaveMutation(values) {
  const term = {
    id: values.term.id,
    year: values.term.year,
    filterByStatus: false,
    updaterId: 0,
    initialDate: 0,
    finalDate: 0,
  };
  const schoolGrade = {
    id: 0,
    active: false,
    order: 0,
    filterByStatus: false,
    updaterId: 0,
  };

  const responsible = {
    id: values.responsible ? values.responsible.value : 0,
    usuarioChatInterno: false,
    ativo: true,
    filterByStatus: false,
    pedagogicAdm: false,
    updaterId: 0,
    usuarioChat: false,
    active: false,
  };
  const responsibleAux = {
    id: values.responsibleAux ? values.responsibleAux.value : 0,
    usuarioChatInterno: false,
    ativo: true,
    filterByStatus: false,
    pedagogicAdm: false,
    updaterId: 0,
    usuarioChat: false,
    active: false,
  };

  let team = [];
  if (values.team && values.team.length) {
    team = values.team.map((item) => ({
      id: item.employee.id,
      usuarioChatInterno: false,
      ativo: true,
      filterByStatus: false,
      pedagogicAdm: false,
      updaterId: 0,
      usuarioChat: false,
      active: false,
    }));
  }

  let registeredStudents = [];
  if (values.registeredStudents && values.registeredStudents.length) {
    registeredStudents = values.registeredStudents.map((item) => ({
      id: item.id,
      initialDateInMilli: item.initialDateInMilli,
      finalDateInMilli: item.finalDateInMilli,
      active: item.active,
      student: {
        ...item.student,
        filterByStatus: true,
        updaterId: 0,
        active: true,
        activeOnLoggedPeriod: true,
        legacyId: 0,
        dateOfBirth: 0,
      },
      schoolShift: {
        ...item.schoolShift,
        filterByStatus: false,
        updaterId: 0,
        active: false,
      },
      filterByStatus: false,
      updaterId: 0,
    }));
  }

  const academicCalendar = {
    id: values.academicCalendar ? values.academicCalendar.id : 0,
  };

  const courseStep = {
    id: values.courseStep.id,
    cycleQuantity: values.courseStep.cycleQuantity,
  };

  const classShift =
    values.classShift && values.classShift.id
      ? {
          id: values.classShift.id,
          filterByStatus: false,
          updaterId: 0,
          active: true,
        }
      : null;

  const mappedCommunicationChannels = values.communicationChannels
    ? values.communicationChannels.map((item) => ({
        id: item.id,
        unreadMessageQuantity: item.unreadMessageQuantity,
        active: item.active,
      }))
    : [];

  const query = `mutation {
    classSave(                              
      schoolClass: {id: ${values.id ? values.id : 0}
              , term: ${JSON.stringify(term).replace(/"([^(")"]+)":/g, '$1:')}
              , schoolGrade: ${JSON.stringify(schoolGrade).replace(
                /"([^(")"]+)":/g,
                '$1:'
              )}
              , name: "${values.name}"
              , shortName: "${values.shortName}"
              , capacity: ${values.capacity ? values.capacity : 0}
              , responsible: ${JSON.stringify(responsible).replace(
                /"([^(")"]+)":/g,
                '$1:'
              )}
              , responsibleAux: ${JSON.stringify(responsibleAux).replace(
                /"([^(")"]+)":/g,
                '$1:'
              )}
              , active: ${values.active}
              , filterByStatus: false
              , updaterId: 0              
              , studentsQuantity: 0
              , year: ${term.year}
              , team: ${JSON.stringify(team).replace(/"([^(")"]+)":/g, '$1:')}
              , enrollments: ${JSON.stringify(registeredStudents).replace(
                /"([^(")"]+)":/g,
                '$1:'
              )}
              ,communicationChannels: ${JSON.stringify(
                mappedCommunicationChannels
              ).replace(/"([^(")"]+)":/g, '$1:')}
              , singleClassShift: ${values.singleClassShift}
              , classShift: ${JSON.stringify(classShift).replace(
                /"([^(")"]+)":/g,
                '$1:'
              )}
              , academicCalendar: ${JSON.stringify(academicCalendar).replace(
                /"([^(")"]+)":/g,
                '$1:'
              )}
              , courseStep: ${JSON.stringify(courseStep).replace(
                /"([^(")"]+)":/g,
                '$1:'
              )}

          }),
    {
    id 
    classShift { id }
    }
}`;
  return query;
}

export function classListActivesByFunc() {
  const query = `{classListActivesByFunc{id, name,year,term{id, name, year}, value, label}}`;
  return query;
}

export function classListActives() {
  const query = `{classListActives{id, name}}
`;
  return query;
}

export function classRemoveMutation(id) {
  const mutation = `mutation {classRemove(id: ${id})}`;
  return mutation;
}

export function comChannelListByClass(classId) {
  const mutation = `{
  comChannelListByClass(
      classId:${classId}
  ) {
    id
    name
    active
    unreadMessageQuantity
  }
}
`;
  return mutation;
}

export function classListActivesByFuncForClassDiary() {
  return `{classListActivesByFunc{
        id, 
        name,
        classShift { 
            id
            name
        }
        courseStep {
            id 
            fullName
        }
        
    }
}`;
}

export function classListByCourseStagePeriod(
  courseId,
  courseStepId,
  periodId,
  cycleNumber
) {
  return `{classListByCourseStagePeriod(
    courseId: ${courseId}
    courseStepId: ${courseStepId}
    periodId: ${periodId}
    cycleNumber: ${cycleNumber}
    )
    {
        id
        name
        status
        releaseDate
        releaseDateWithHourPtBr
        automaticCycleRelease
    }
}`;
}

export function activeClassCountByCourse(courseId) {
  return `
   {
    activeClassCountByCourse(courseId: ${courseId})
   }`;
}
